<template>
  <div>
    <IconTooltip
      :className="$style.svgPosition"
      :contentContainerClass="$style.contentContainer"
      :iconClass="$style[state.iconClass]"
      :iconComponent="state.icon"
    >
      <div
        v-if="state.tooltip"
      >
        {{ state.tooltip }}
      </div>
    </IconTooltip>
  </div>
</template>

<script>
import { ItemTypeConsts, StoreModelMap, StoreModuleMap } from 'client/util/Constants';
import { findKey, get } from 'lodash';
import { mapState } from 'vuex';
import IconTooltip from 'components/Tooltip/IconTooltip.vue';
import PausedStatusIcon from 'public/img/icons/pausedStatus.svg?inline';
import Success from 'public/img/icons/icon-status-success.svg?inline';
import WarningStatusIcon from 'public/img/icons/critical.svg?inline';

const orgModel = StoreModelMap[ItemTypeConsts.organizations];
const settingsModule = StoreModuleMap[ItemTypeConsts.settings];

export default {
  name: 'ConditionalPolicyStatus',

  components: {
    IconTooltip,
  },

  props: {
    item: {
      default: () => ({ item: { disabled: true } }),
      type: Object,
      validator: item => item && item.disabled !== undefined,
    },
  },

  data() {
    return {
      states: {
        active: {
          check: () => this.isActive,
          icon: Success,
        },
        inactive: {
          check: () => this.isInactive,
          icon: PausedStatusIcon,
          tooltip: 'This authentication policy is currently disabled.',
        },
        warning: {
          check: () => this.isWarning,
          icon: WarningStatusIcon,
          iconClass: 'warningStatus',
          tooltip: 'This policy uses a device condition, however device certificate distribution '
          + 'is disabled. Turn on device certificate distribution or remove device conditions to '
          + 'ensure uninterrupted access for your users.',
        },
      },
    };
  },

  computed: {
    ...mapState(orgModel, { organization: 'item' }),
    ...mapState(settingsModule, ['orgId']),

    certDistributionIsEnabled() {
      return this.organization.settings
        ? this.organization.settings.deviceIdentificationEnabled
        : false;
    },

    isActive() {
      return !this.isInactive && !this.isWarning;
    },

    isInactive() {
      return this.item.disabled;
    },

    isWarning() {
      return !this.isInactive
      && !this.certDistributionIsEnabled
      && !!get(this.item, 'conditions.expressions.device');
    },

    state() {
      const state = findKey(this.states, stateToCheck => stateToCheck.check()) || 'active';
      return this.states[state];
    },
  },
};
</script>

<style module>
@value (jcWarning) from '~css/brand-colors.css';

.svgPosition {
  margin-top: 5px;
}

.contentContainer {
  min-height: 0;
}

.warningStatus path {
  fill: jcWarning;
}
</style>
